import Footer from '../Components/Footer';
import Header from '../Components/Header';
import ProfileCom from '../Components/ProfileCom';

function Profile() {

    return (
        <div>
            <Header/>
            <ProfileCom/>
            <Footer/>
        </div>
    );
}

export default Profile;